import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import AdminPage from "components/template/adminpage";

export default function EmployeeDashboard() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <AdminPage title="Dashboard">
        <Stack direction="row" spacing={2}>
          <Button component={Link} to="/employee-portal/attendance" variant="contained">Presenze</Button>
          <Button component={Link} to="/employee-portal/activities" variant="contained">Attività</Button>
        </Stack>
      </AdminPage>
    </React.Fragment>
  );
}
